var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWave = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9108 27.3103L34.8221 15.3712C34.8221 15.3712 34.4609 13.4349 32.5225 13.8852C30.5841 14.3354 31.0199 16.1931 31.0199 16.1931L33.8256 26.9642L29.0905 15.4279C29.0905 15.4279 28.3398 13.7585 26.7244 14.4098C25.316 14.9784 25.3422 16.1504 25.7371 17.1384C26.0411 17.8923 30.4018 28.7409 30.4018 28.7409L24.8356 18.4941C24.8356 18.4941 23.9752 16.8122 22.2809 17.6996C20.5866 18.5869 21.2216 19.8069 21.478 20.3205C21.7345 20.8342 29.742 35.1346 27.1702 31.1202C27.1143 31.033 27.1185 31.0374 27.0274 30.8965C26.3241 29.7883 23.2354 24.9391 22.6436 24.1478C22.0519 23.3565 21.2674 22.8425 19.9334 23.7259C18.3322 24.7892 19.8158 26.6102 19.8158 26.6102C19.8158 26.6102 22.7099 31.2046 23.8763 33.717C25.0427 36.2294 26.8029 39.4855 28.3489 40.8509C29.8949 42.2164 31.6386 45.3461 31.6386 45.3461",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4703 40.1318C41.4703 40.1318 40.72 37.7791 42.2557 35.3925C43.7915 33.006 43.3831 30.229 42.8725 28.8641C42.3618 27.4993 40.9819 25.3367 42.1077 22.8961C43.2335 20.4554 41.107 20.2906 40.1646 20.7974C37.387 22.2928 37.9079 27.3062 37.9079 27.3062",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0439 32.3183C34.0489 34.1503 32.5692 36.2656 34.3649 39.147",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0333 15.6953C43.7949 16.062 44.4927 16.6247 45.041 17.3717C45.5894 18.1186 45.9431 19.0116 46.053 19.8785",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 13.5369C45.1459 14.0681 46.1568 14.8834 46.9512 15.9657C47.7457 17.0479 48.2582 18.3416 48.4173 19.5976",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wave.13aa9e9254201be586fbab3d353606c2.svg";